import { useCallback, useEffect, useState } from "react";

const getInitial = () => (document.documentElement.classList.contains("dark") ? "dark" : "light");

// Light / dark theme persisted in localStorage (initial value set in public/index.html).
export default function useTheme() {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    localStorage.setItem("spc-theme", theme);
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#080C14" : "#F6F7F9");
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  return { theme, toggle };
}
